import styled from 'styled-components'

export const Container = styled.section`
  position: relative;
  padding: 100px 20px;
  background-color: ${(props) => props.theme.azulEscuro};
`

export const ConteudoContato = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1.2fr; /* Coluna da esquerda um pouco menor */
  gap: 50px;
  background: ${(props) => props.theme.azulEscuro};

  @media (max-width: 900px) {
    grid-template-columns: 1fr; /* Empilha no celular */
  }
`

export const InfoLateral = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;

  h2 {
    font-size: 40px;
    color: ${(props) => props.theme.azulMuitoClaro};
    margin-bottom: 10px;
  }

  p {
    color: ${(props) => props.theme.azulMuitoClaro};
  }

  .cartao-info {
    display: flex;
    align-items: center;
    gap: 20px;
    background: ${(props) => props.theme.azulPrincipal}; /* */
    padding: 25px;
    border-radius: 20px; /* */
    border: 1px solid ${(props) => props.theme.azulDestaque};
    transition: transform 0.3s;

    &:hover {
      transform: translateX(10px); /* Efeito lateral ao passar o mouse */
      border-color: ${(props) => props.theme.azulAcentuado};
    }

    .icone-box {
      font-size: 30px;
      color: ${(props) => props.theme.azulAcentuado};
      display: flex;
      align-items: center;
    }

    h4 {
      color: #fff;
      font-size: 18px;
      margin-bottom: 4px;
    }
    p {
      color: ${(props) => props.theme.azulClaro};
      font-size: 14px;
    }
  }
`

export const Formulario = styled.div`
  background: rgba(
    255,
    255,
    255,
    0.05
  ); /* Fundo sutil para o card de contato */
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 40px;
  flex: 1;

  h3 {
    font-size: 1.5rem;
    margin-bottom: 25px;
    color: #fff;
  }

  .grupo-input {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    label {
      font-size: 0.9rem;
      color: #fff;
      opacity: 0.7;
      text-align: left;
    }

    input,
    select {
      /* Remove o visual padrão "nada a ver" */
      background: rgba(0, 0, 0, 0.3);
      border: 1px solid rgba(255, 255, 255, 0.15);
      border-radius: 12px;
      padding: 14px;
      color: #fff;
      font-size: 1rem;
      outline: none;
      transition: all 0.3s ease;

      &::placeholder {
        color: rgba(255, 255, 255, 0.3);
      }

      /* Efeito de foco para combinar com a interatividade dos cards */
      &:focus {
        border-color: #007bff;
        background: rgba(0, 0, 0, 0.5);
        box-shadow: 0 0 10px rgba(0, 123, 255, 0.2);
      }
    }

    /* Estilizando a seta do select para não ser a padrão feia */
    select {
      cursor: pointer;
      appearance: none;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 12px center;
      background-size: 16px;
      padding-right: 40px;

      option {
        background: #0a192f; /* Fundo do menu suspenso igual ao site */
        color: #fff;
      }
    }
  }
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 25px;

  button {
    flex: 1;
    padding: 14px;
    border-radius: 12px;
    border: none;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-3px);
      filter: brightness(1.1);
    }

    &:disabled {
      background: #555; /* Cor cinza para parecer desativado */
      opacity: 0.5;
      cursor: not-allowed;
      transform: none !important; /* Tira o efeito de subir no hover */
    }
  }

  .btn-wpp {
    background: #25d366;
    color: #fff;
  }

  .btn-insta {
    background: linear-gradient(
      45deg,
      #f09433,
      #e6683c,
      #dc2743,
      #cc2366,
      #bc1888
    );
    color: #fff;
  }
`

export const CustomAlert = styled.div`
  white-space: nowrap;
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(10, 25, 47, 0.95); /* Azul escuro do fundo */
  color: #fff;
  padding: 16px 24px;
  border-radius: 12px;
  border: 1px solid #007bff; /* Cor de destaque */
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 10000;
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`
